export class BaseEntity {
    id?: number;

    created?: string;

    updated?: string;
}
